export default __webpack_public_path__ + "static/media/img-slider-asaph-6.2bc0e794.png";